
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';

const NotificationsDropdown = () => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <div className="bg-interactive w-[4.2rem] h-[4.2rem] rounded-full flex items-center justify-center cursor-pointer">
          <NotificationsIcon />
        </div>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        className="w-[30rem] bg-white dark:bg-[#272727] border-none hidden rounded-lg shadow-lg notifications-dropdown p-0"
        align="end"
        sideOffset={8}
      >
        content
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default NotificationsDropdown;

function NotificationsIcon({ className }: { className?: string }) {
  return (
    <svg width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M13.9887 11.8401C13.5841 11.1052 12.9825 9.02591 12.9825 6.31011C12.9825 1.57617 8.1218 -1.38254 4.23321 0.984427C2.4285 2.08294 1.31676 4.11308 1.31676 6.31011C1.31676 9.02668 0.714514 11.1052 0.309854 11.8401C-0.142529 12.658 0.414523 13.6855 1.31255 13.6896L1.31676 13.6896H4.29226C4.74179 16.0086 7.4039 16.945 9.08406 15.375C9.5567 14.9334 9.88059 14.3419 10.007 13.6896H12.9825C13.8806 13.6883 14.4405 12.6626 13.9905 11.8433L13.9887 11.8401ZM7.14965 14.9195C6.40829 14.9193 5.74753 14.4265 5.5004 13.6896H8.79891C8.55178 14.4265 7.89102 14.9193 7.14965 14.9195ZM1.31676 12.4597C1.87817 11.4419 2.48334 9.08356 2.48334 6.31011C2.48334 2.52296 6.37193 0.155983 9.48281 2.04956C10.9266 2.92837 11.816 4.55249 11.816 6.31011C11.816 9.08126 12.4197 11.4396 12.9825 12.4597H1.31676Z" fill="#3463FD" stroke="#3463FD" strokeWidth="0.3" />
    </svg>
  );
}
